import WidgetModel from './WidgetModel';

export {
    WidgetModel
};



// WEBPACK FOOTER //
// ./plugins/slicer_cli_web/web_client/models/index.js